
import React from 'react';
import { useTutorial } from '@/hooks/use-tutorial';
import { TutorialOverlay } from '@/components/ui/tutorial-overlay';

export function TutorialManager() {
  const {
    activeTutorial,
    currentStep,
    currentStepIndex,
    isFirstStep,
    isLastStep,
    nextStep,
    prevStep,
    skipTutorial,
    completeTutorial
  } = useTutorial();

  if (!activeTutorial || !currentStep) {
    return null;
  }

  return (
    <TutorialOverlay
      step={currentStep}
      isFirstStep={isFirstStep}
      isLastStep={isLastStep}
      currentStepIndex={currentStepIndex}
      totalSteps={activeTutorial.steps.length}
      onNext={nextStep}
      onPrev={prevStep}
      onSkip={skipTutorial}
      onComplete={completeTutorial}
    />
  );
}
